/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateContractHirerInfo = {
  properties: {
    id: {
      type: 'string',
    },
    selectedSignerIds: {
      type: 'array',
      contains: {
        type: 'string',
      },
    },
  },
} as const;
